<script>
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user";
    import {PASSWORD_TIP} from "../lib/constants";
    import PasswordControl from "../components/controls/PasswordControl.svelte";
    import Warning from "../components/pages/Warning.svelte";
    import Prompt from "../components/pages/Prompt.svelte";
    import {setFocusTo} from "../lib/lib";

    export let hash;

    let memberId = null;
    let password = null;
    let confirmPassword = null;
    let formError = null;
    let passwordChanged = false;

    let warning = null;

    const setError = err => {
        warning = null;
        formError = null;

        if (err.code) {
            let warnings = ['account_not_found', 'account_not_active', 'action_not_found'];
            if (warnings.indexOf(err.code) > -1) {
                warning = err.code;
            } else {
                formError = err.message;
            }
        }
    }

    const load = () => {
        const onSuccess = result => {
            if (result.action !== 'reset-password') {
                warning = 'action-invalid';
                return;
            }

            memberId = result.data.member_id;
            setFocusTo('password');
        }

        const onFailure = err => {
            setError(err);
        }

        R.handle(R.action.confirm, hash, onSuccess, onFailure, LOADER.PAGE);
    }

    const save = () => {
        const onSuccess = result => {
            user.setUser(result);
            passwordChanged = true;
        }

        const onFailure = err => {
            setError(err);
        };

        formError = null;

        if (password !== confirmPassword) {
            formError = "Η επαλήθευση του κωδικού δεν ταιριάζει με τον νέο κωδικό που πληκτρολογήσατε!";
            setFocusTo('confirmPassword');
            return;
        }

        R.handle(R.account.setPassword, {hash, password}, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<div class="container">
    <div class="mb-5">
        <h1>Αλλαγή Κωδικού Λογαριασμού</h1>
        <div class="heading-separator"></div>
    </div>

    {#if warning}
        <Warning {warning}/>
    {/if}

    {#if !warning && memberId != null}
        {#if !passwordChanged}
            <p>
                Πληκτρολογήστε τον νέο κωδικό του λογαριασμού σας.
            </p>
            <p class="small text-gray mt-1">{ PASSWORD_TIP }</p>
            <form on:submit|preventDefault|stopPropagation="{ save }">
                <div class="row">
                    <div class="col-xl-3">
                        <div class="form-group">
                            <label>Νέος κωδικός</label>
                            <PasswordControl id="password" bind:value="{ password }"/>
                        </div>
                        <div class="form-group">
                            <label>Επαλήθευση κωδικού</label>
                            <PasswordControl id="confirmPassword" bind:value="{ confirmPassword }"/>
                        </div>
                        {#if formError}
                            <div class="alert alert-danger small">
                                { formError }
                            </div>
                        {/if}
                        <button class="btn btn-primary btn-block">Ενημέρωση λογαριασμού</button>
                    </div>
                </div>
            </form>
        {:else}
            <Prompt icon="user" message="Η ενημέρωση του κωδικού του λογαριασμού σας ολοκληρώθηκε!|Έχετε συνδεθεί στον λογαριασμό σας."/>
        {/if}
    {/if}
</div>